import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SharedModule } from '../shared/shared.module';
import { AuthRoutingModule } from './auth-routing.module';
import { PlanningComponent } from './planning/planning.component';
import { ToolbarSubComponent } from './planning/toolbar-sub/toolbar-sub.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtInterceptor } from '../interceptors/jwt.interceptor';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { PlanningNewComponent } from './planning-new/planning-new.component';
import { TabViewModule } from 'primeng/tabview';
import { CheckboxModule } from 'primeng/checkbox';
import { DateFnsModule } from 'ngx-date-fns';
import { DialogModule } from 'primeng/dialog';
import { PCustomMonthFormatPipe } from './pipes/custom-month-format.pipe';
import { RouterModule } from '@angular/router';
import { CustomDayFormatPipe } from './pipes/custom-day-format.pipe';
import { TableModule } from 'primeng/table';
import { PlanningViewComponent } from './planning-view/planning-view.component';
import { KeysPipe } from '../keys.pipe';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { PlanningMeetingsComponent } from './planning-view/planning-meetings/planning-meetings.component';


registerLocaleData(localeEs, 'es');

@NgModule({
  declarations: [
    DashboardComponent,
    PlanningComponent,
    ToolbarSubComponent,
    PCustomMonthFormatPipe,
    PlanningNewComponent,
    CustomDayFormatPipe,
    PlanningViewComponent,
    KeysPipe,
    PlanningMeetingsComponent,
  ],
  imports: [
    AuthRoutingModule,
    CommonModule,
    SharedModule,
    RouterModule,
    FormsModule,
    MultiSelectModule,
    ReactiveFormsModule,
    CalendarModule,
    AutoCompleteModule,
    TabViewModule,
    CheckboxModule,
    DateFnsModule,
    DialogModule,
    TableModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
    {
      provide: LOCALE_ID,
      useValue: 'es'
    }
  ]
})
export class AuthModule { }
